export var DEPLOY_DATE = new Date('2026-08-18T14:17:13+0000');
